import JobsPage from '@components/JobsPage';
import { DEFAULT_DATE_POSTED, locationSlugs, termSlugs } from '@src/constants';
import { useJobSearch } from '@src/state/jobSearch';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { use100vh } from 'react-div-100vh';
import { useMediaQuery } from 'react-responsive';
import styles from '../style.module.css'
import { searchJobs, searchJobsByTerm, searchJobsByLocation } from '@src/graphqlqueries'
import getJobDbPages, { getInputForSlug, getParamsForSlug, getSEOParamsForSlug } from '@src/seo/getJobDbPages';
import { gql } from "@apollo/client";
import { createApolloClient, useApollo } from "@src/apollo";
import SEOTags from '@components/SEOTags';
import { isLocationSlug, isTermSlug } from '@src/helpers/seo';

const NavBar = dynamic(() => import('@components/Navbar'))

const SearchProvider = dynamic(() =>
  import('@src/state/jobSearch').then((mod) => mod.SearchProvider),
)

const MobileFilter = dynamic(
  () => import('../../../components/MobileFilter/index'),
  { ssr: false },
)

const MobileCreateAlert = dynamic(
  () => import('../../../components/MobileCreateAlert/index'),
  { ssr: false },
)

const filterStates = {
    contract: true,
    fullTime: true,
    hybrid: true,
    partTime: true,
    fullRemote: true,
    remoteOptional: true,
    intern: true,
    junior: true,
    midLevel: true,
    senior: true,
    executive: true,
    remoteFirst: true,
    missionDriven: true,
    flexibleHours: true,
    workFromAnywhere: true,
    datePosted: DEFAULT_DATE_POSTED,
  }

export default function JobPage({ staticJobs, staticParams, seoParams }) {
    console.log(seoParams)
    const router = useRouter();
    const { slug } = router.query;

    const [firstLoadComplete, setFirstLoadComplete] = useState(false)
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 820px)' })
    const mobileHeight = use100vh()

    useEffect(() => {
        setFirstLoadComplete(true);
    }, [])

    const mobileStyle = isTabletOrMobile
    ? {
        height: mobileHeight,
        overflow: 'hidden',
      }
    : null    

    return (
        <SearchProvider>
          <div className={styles.searchLayoutContainer} style={mobileStyle}>
            <NavBar isSearchNav />
            <JobsPage
              jobPostings={[]}
              jobSeekerId={null}
              applicationMap={{}}
              staticJobs={staticJobs}
              staticParams={staticParams}
            />
          </div>
          <MobileFilter />
          <MobileCreateAlert />
          <SEOTags title={seoParams?.title} description={seoParams?.description} url={seoParams?.url} />
        </SearchProvider>
      )
}

export async function getStaticPaths() {
  try {
    const paths = [] //await getJobDbPages()
    paths.push(...termSlugs.map((term) => ({ params: { slug: term.slug } })))
    paths.push(...locationSlugs.map((term) => ({ params: { slug: term.slug } })))
    console.log(paths)
    paths.push({ params: { slug: "search" } })
    return { paths, fallback: true }
  } catch (error) {
    console.log('error with static paths: ', error) 
  }
}


export async function getStaticProps(context) {
  const { slug } = context.params;

  if (slug === "search") {
    return {
      props: {
        staticJobs: [],
        staticParams: {},
        seoParams: {
          title: `Search for jobs on Lifeshack`,
          description: `Search for jobs on LifeShack`, 
          url: `https://lifeshack.com/jobs/search/`,
          type: 'website', 
          image: null, 
          noFollow: true
        }
      },
      revalidate: 86400
    }
  }
  
  try {
    const jobs = await getJobsForSlug(slug)
    const params = await getParamsForSlug(slug)
    const seoParams = await getSEOParamsForSlug(slug)
  
    return {
      props: {
        staticJobs: jobs,
        staticParams: params,
        seoParams
      }
    }
  } catch (error) {
    console.log('error getting static props: ', error)
    return {
      props: {}
    }
  }
}

async function getJobsForSlug(slug) {
    if (slug === "search") {
      return []
    }

    const client = createApolloClient(null)
    const vars = await getInputForSlug(slug)

    let results = null 

    if (isTermSlug(slug)) {
      const { data } = await client.query({
        query: gql(searchJobsByTerm),
        variables: {
          ...vars
        },
      });
      results = data
    } else if (isLocationSlug(slug)) {
      const { data } = await client.query({
        query: gql(searchJobsByLocation),
        variables: {
          ...vars
        },
      });
      results = data      
    } else {
      const { data } = await client.query({
        query: gql(searchJobs),
        variables: {
          ...vars
        },
      });
      results = data            
    }


    if (results?.searchJobsByTerm) {
        return results.searchJobsByTerm
    }

    if (results?.searchJobsByLocation) {
        return results.searchJobsByLocation
    }

    return []
}

JobPage.getLayout = (page) => {
    return <>{page}</>
}